module.exports = __webpack_public_path__ + "img/image-02.39e98938.webp";